import React from 'react';

import { Routes } from '../../navigation';
import { ForgotPasswordForm } from './components';
import { ForgotPasswordPageCmp } from './types';

const ForgotPasswordPage: ForgotPasswordPageCmp = () => {
  return <ForgotPasswordForm />;
};

ForgotPasswordPage.route = Routes.ForgotPasswordPage;

export default ForgotPasswordPage;
